var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-box"},[_c('img',{attrs:{"src":require("@/assets/img/vipDay/vip-day.jpg"),"alt":"灵云听语会员日"}})])}]

export { render, staticRenderFns }